export const mmCodeTableContants = {
    translationGroup: "_codetable"
}

